import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Warning } from '../../Warning/Warning';
import { Text } from '@topconagriculture/react-components';
import { useTranslation } from 'react-i18next';
import { useWarningClick } from '../useWarningClick';
import { useDashboardConfig } from '../../../../hooks';
const useStyles = makeStyles(() => ({
    warningContainer: {
        display: 'flex',
        gap: 10,
        width: '100%',
        maxWidth: 450,
        justifyContent: 'space-between',
        height: 'fit-content',
        margin: 'auto auto',
    },
    warningWrapper: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        textAlign: 'center',
        gap: 20,
        alignItems: 'center',
    },
    delay: {
        display: 'flex',
        backgroundColor: '#F4F4F4',
        minHeight: 80,
    },
    iconWrapper: {
        width: 30,
        padding: 20,
    },
    messageWrapper: { padding: 20 },
    title: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    capitalized: {
        textTransform: 'capitalize',
    },
}));
export const WarningsSBlock = (props) => {
    const { criticalCount, earlyCount, deliveryDelay } = props;
    const { RESOURCES_BASE_URL } = useDashboardConfig();
    const { onCriticalClick, onEarlyClick } = useWarningClick();
    const { t } = useTranslation();
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classes.warningContainer },
            React.createElement("div", { className: classes.warningWrapper },
                React.createElement(Warning, { onClick: onCriticalClick, color: "#E46A68", diameter: 90, fontSize: 28, amount: criticalCount }),
                React.createElement("div", { className: classes.title },
                    React.createElement(Text, { bold: true, className: classes.capitalized }, t('common:critical')),
                    React.createElement("br", null),
                    React.createElement(Text, null, t('widget:warnings')))),
            React.createElement("div", { className: classes.warningWrapper },
                React.createElement(Warning, { onClick: onEarlyClick, color: "#FA9E2D", diameter: 90, fontSize: 28, amount: earlyCount }),
                React.createElement("div", { className: classes.title },
                    React.createElement(Text, { bold: true, className: classes.capitalized }, t('common:early')),
                    React.createElement("br", null),
                    React.createElement(Text, null, t('widget:warnings'))))),
        deliveryDelay && (React.createElement("div", { className: classes.delay },
            React.createElement("div", { className: classes.iconWrapper },
                React.createElement("img", { width: 22, height: 17, src: `${RESOURCES_BASE_URL}/assets/images/dashboard/icons/alert_high.svg`, alt: "Alert high" })),
            React.createElement("div", { className: classes.messageWrapper },
                React.createElement(Text, { block: true }, t('widget:inventory:delay_message')))))));
};
//# sourceMappingURL=WarningsSBlock.js.map